import styled from "styled-components";

export const ModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const ReasonTitle = styled.h3`
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
    text-align: center;
    padding-bottom: 12px;
    border-bottom: 2px solid #ff4d4f;
`;

export const ReasonOptionsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    .ant-radio-group {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .ant-radio-wrapper {
        font-size: 14px;
        color: #333;
        padding: 8px 0;

        .ant-radio {
            .ant-radio-inner {
                border-color: #d9d9d9;

                &:hover {
                    border-color: #ff4d4f;
                }

                &::after {
                    background-color: #ff4d4f !important;
                }
            }

            &.ant-radio-checked {
                .ant-radio-inner {
                    border-color: #ff4d4f !important;
                    background-color: transparent !important;

                    &::after {
                        background-color: #ff4d4f !important;
                    }
                }

                &::after {
                    border: 1px solid #ff4d4f !important;
                }
            }

            &:hover,
            &:focus {
                .ant-radio-inner {
                    border-color: #ff4d4f !important;
                }
            }
        }

        &:hover .ant-radio .ant-radio-inner {
            border-color: #ff4d4f;
        }

        &.ant-radio-wrapper-checked {
            .ant-radio-inner {
                border-color: #ff4d4f !important;

                &::after {
                    background-color: #ff4d4f !important;
                }
            }
        }
    }

    /* Global override for any missed cases */
    .ant-radio-checked .ant-radio-inner {
        border-color: #ff4d4f !important;

        &::after {
            background-color: #ff4d4f !important;
        }
    }

    .ant-radio:hover .ant-radio-inner,
    .ant-radio-input:focus + .ant-radio-inner {
        border-color: #ff4d4f !important;
    }
`;

export const ReasonOption = styled.div`
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    background-color: #fafafa;
    transition: all 0.3s ease;

    &:hover {
        border-color: #ff4d4f;
        background-color: rgba(255, 77, 79, 0.05);
    }

    .ant-radio-wrapper {
        margin: 0;
        width: 100%;

        .ant-radio {
            margin-right: 12px;
        }
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    gap: 12px;
    justify-content: center;
    padding-top: 16px;
    border-top: 1px solid #e8e8e8;
`;

export const CancelButton = styled.button`
    padding: 10px 24px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    background: #fff;
    color: #666;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease;
    min-width: 100px;

    &:hover {
        border-color: #ff4d4f;
        color: #333;
    }
`;

export const ConfirmButton = styled.button`
    padding: 10px 24px;
    border: none;
    border-radius: 6px;
    background: ${props => (props.disabled ? "#d3d3d3" : "#ff4d4f")};
    color: ${props => (props.disabled ? "#999" : "#333")};
    cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
    font-size: 14px;
    font-weight: 600;
    transition: all 0.3s ease;
    min-width: 100px;

    &:hover:not(:disabled) {
        background: #d9363e;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(255, 77, 79, 0.3);
    }

    &:active:not(:disabled) {
        transform: translateY(0);
    }
`;

export const OtherReasonInput = styled.textarea`
    width: 100%;
    padding: 12px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    font-size: 14px;
    color: #333;
    resize: vertical;
    min-height: 80px;
    transition: all 0.3s ease;
    font-family: inherit;

    &:focus {
        outline: none;
        border-color: #ff4d4f;
        box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.1);
    }

    &::placeholder {
        color: #999;
    }
`;
